import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Card, CardHeader, CardBody, Input, Container, Col, Row, Button, Alert, Form, FormGroup, Label } from 'reactstrap';
import { resetPassword } from '../../store/user/actions'
import { validate } from './_validate'

class ResetPassword extends Component {

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(values) {
        const params = new URLSearchParams(this.props.location.search);
        const token = params.get('token');

        this.props.resetPassword(token, values.password, values.confirmPassword);
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row size='sm'>
                <Col xs='12' >
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col xs="12">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                </Col>
            </FormGroup>
        )
    }

    renderResetForm() {
        const { handleSubmit, loading, error } = this.props;

        return (
            <div>
                {
                    error && (
                        <Alert color="danger">
                            {error}
                        </Alert>
                    )
                }
                <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))} >
                    <Field name='password' label='Nueva Contraseña:' type='password' component={this.renderInputField} />
                    <Field name='confirmPassword' label='Confirmar Contraseña:' type='password' component={this.renderInputField} />
                    <Row>
                        <Col className='mt-2'>
                            <Button disabled={loading} type='submit' color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    renderSuccess() {
        return (
            <div>
                <Row>
                    <Col>
                        <Alert color="success">
                            Contraseña restablecida satisfactoriamente.
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button color='primary' onClick={() => this.props.history.push('/login')} >Aceptar</Button>
                    </Col>
                </Row>
            </div>
        )
    }

    render() {

        const { success } = this.props;

        return (
            <Container>
                <Row>
                    <Col md='2' lg='3' />
                    <div className='mt-5 col-md-8 col-lg-6'>
                        <Card>
                            <CardHeader>
                                Reestablecer tu contraseña
                            </CardHeader>
                            <CardBody>
                                {
                                    !success ? this.renderResetForm() : this.renderSuccess()
                                }
                            </CardBody>
                        </Card>
                    </div>
                    <Col md='2' lg='3' />
                </Row>
            </Container>
        );
    }
}



function mapStateToProps(state) {
    const { success, error, loading } = state.user.resetPassword;

    return {
        success,
        error,
        loading
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        resetPassword
    }, dispatch)
}

export default reduxForm({
    form: 'ResetPasswordForm',
    touchOnBlur: false,
    validate
})(
    connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
)


// WEBPACK FOOTER //
// ./src/scenes/ResetPassword/ResetPassword.js